import React, { useState } from "react";
import { Button, Input, message, Upload, DatePicker, Rate } from "antd";
import { MdOutlineNavigateNext } from "react-icons/md";
import { useDrawer } from "../../../../context/drawer";
import ReactQuill from "react-quill";
import { PlusOutlined } from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import axios from "axios";
import moment from "moment";

export default function AddReview() {
  const [loading, setLoading] = useState(false);
  const { toggleDrawer } = useDrawer();

  const [formData, setFormData] = useState({
    name: "",
    review_date: null,
    rating: 0,
    review_content: "",
  });

  const [fileList, setFileList] = useState([]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmitClick = async () => {
    const { name, review_date, rating, review_content } = formData;

    if (
      !name ||
      !review_date ||
      !rating ||
      !review_content ||
      fileList.length === 0
    ) {
      message.warning("Please fill all fields and upload an image.");
      return;
    }

    try {
      setLoading(true);

      const data = new FormData();
      data.append("action", "add_review");
      data.append("name", name);
      data.append("rating", rating);
      data.append(
        "review_date",
        moment(review_date).format("YYYY-MM-DD")
      );
      data.append("content", review_content);

      if (fileList[0]?.originFileObj) {
        data.append("image", fileList[0].originFileObj);
      }

      const resp = await axios.post(
        "https://skdm.in/server/sdg/reviews.php",
        data,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (resp?.data) {
        message.success(resp.data.message || "Review added successfully!");
        toggleDrawer();

        // reset form
        setFormData({
          name: "",
          review_date: null,
          rating: 0,
          review_content: "",
        });
        setFileList([]);
      } else {
        message.error("Failed to add review.");
      }
    } catch (err) {
      console.error("Add review error:", err);
      message.error("Failed to add review. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-review-form">
      <label>Name</label>
      <Input
        name="name"
        value={formData.name}
        onChange={handleInputChange}
        placeholder="Enter reviewer name"
      />

      <label className="mt-3">Review Date</label>
      <DatePicker
        className="w-100"
        value={formData.review_date}
        onChange={(date) =>
          setFormData((prev) => ({ ...prev, review_date: date }))
        }
      />

      <label className="mt-3">Rating</label>
      <Rate
        value={formData.rating}
        onChange={(value) =>
          setFormData((prev) => ({ ...prev, rating: value }))
        }
      />

      <label className="mt-3">Review Content</label>
      <ReactQuill
        value={formData.review_content}
        onChange={(value) =>
          setFormData((prev) => ({ ...prev, review_content: value }))
        }
      />

      <label className="mt-3 d-block">Image</label>
      <Upload
        listType="picture-card"
        maxCount={1}
        fileList={fileList}
        onRemove={() => setFileList([])}
        beforeUpload={(file) => {
          const newFile = {
            uid: file.uid || Date.now().toString(),
            name: file.name,
            status: "done",
            originFileObj: file,
          };
          setFileList([newFile]);
          return false;
        }}
        accept="image/*"
      >
        {fileList.length === 0 && (
          <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
          </div>
        )}
      </Upload>

      <div className="buttonGroup w-100 d-flex justify-content-end mt-4">
        <Button
          className="otherButtons active"
          icon={<MdOutlineNavigateNext />}
          onClick={handleSubmitClick}
          loading={loading}
        >
          Submit
        </Button>
      </div>
    </div>
  );
}
